import HelperMixin from '../../../Shared/HelperMixin.vue';

export default {
    name: 'SendNotificationByTarget',
    mixins: [HelperMixin],
    data() {
        return {
            ruleForm: {
                Title: '',
                Content: '',
                TargetType: '',
                TargetId: null
            },
            rules: {
                Title: [{ required: true, message: 'Title is required', trigger: 'blur' }],
                Content: [{ required: true, message: 'Content is required', trigger: 'blur' }],
                TargetType: [{ required: true, message: 'Select a target', trigger: 'change' }],
                TargetId: [
                    {
                        required: true,
                        message: 'Target Id is required for this target type',
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (!this.needsTargetId) return callback();
                            if (value == null || value === '' || (typeof value === 'number' && value <= 0))
                                return callback(new Error('Required'));
                            callback();
                        }
                    }
                ]
            },
            schools: [],
            sending: false,
            lastResult: '',
            lastSuccess: false
        };
    },
    computed: {
        needsSchoolId() {
            const t = (this.ruleForm.TargetType || '').toLowerCase();
            return t === 'allstudentsinschool' || t === 'allparentsinschool';
        },
        needsUserId() {
            return (this.ruleForm.TargetType || '').toLowerCase() === 'user';
        },
        needsTargetId() {
            return this.needsSchoolId || this.needsUserId;
        }
    },
    async created() {
        await this.CheckLoginStatus();
        if (this.needsSchoolId) await this.loadSchools();
    },
    watch: {
        'ruleForm.TargetType'() {
            if (!this.needsSchoolId) this.ruleForm.TargetId = null;
            if (this.needsSchoolId && this.schools.length === 0) this.loadSchools();
        }
    },
    methods: {
        async loadSchools() {
            try {
                const res = await this.$http.GetAllSchools();
                const raw = res.data;
                this.schools = Array.isArray(raw) ? raw : (raw && raw.data) || (raw && raw.info) || [];
            } catch (_) {
                this.schools = [];
            }
        },
        onTargetTypeChange() {
            this.ruleForm.TargetId = null;
            this.lastResult = '';
        },
        submitForm() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (!valid) return;
                const payload = {
                    Title: this.ruleForm.Title.trim(),
                    Content: this.ruleForm.Content.trim(),
                    TargetType: this.ruleForm.TargetType
                };
                if (this.needsTargetId && this.ruleForm.TargetId != null && this.ruleForm.TargetId !== '')
                    payload.TargetId = Number(this.ruleForm.TargetId);
                else
                    payload.TargetId = null;

                this.sending = true;
                this.lastResult = '';
                try {
                    const res = await this.$http.SendNotification(payload);
                    this.lastSuccess = true;
                    const msg = res.data && (res.data.message || res.data.Message);
                    const count = res.data && (res.data.count != null ? res.data.count : '');
                    this.lastResult = msg ? (count !== '' ? `${msg} (${count} users)` : msg) : 'Notification sent successfully.';
                    this.$helper.ShowMessage('success', 'Success', this.lastResult);
                    this.resetForm();
                } catch (err) {
                    this.lastSuccess = false;
                    const msg = err.response && err.response.data ? (typeof err.response.data === 'string' ? err.response.data : (err.response.data.message || err.response.data.Message || JSON.stringify(err.response.data))) : 'Request failed.';
                    this.lastResult = msg;
                    this.$helper.ShowMessage('error', 'Error', msg);
                } finally {
                    this.sending = false;
                }
            });
        },
        resetForm() {
            this.ruleForm.Title = '';
            this.ruleForm.Content = '';
            this.ruleForm.TargetType = '';
            this.ruleForm.TargetId = null;
            this.lastResult = '';
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
        }
    }
};
